import { type FormData, type GroupOptions, COMPONENT_TYPE_RADIOBUTTON } from '@entities/leadCollector';

export type RadiobuttonGroup = GroupOptions & { instanceId: string };

export const getRadiobuttonsFromBodyForm = (bodyForm: FormData | null | undefined): RadiobuttonGroup[] => {
  if (!bodyForm?.components?.length) return [];

  const result: RadiobuttonGroup[] = [];
  for (const c of bodyForm.components) {
    if (c.type === COMPONENT_TYPE_RADIOBUTTON && c.properties != null) {
      result.push({ ...(c.properties as unknown as GroupOptions), instanceId: c.instanceId });
    }
  }
  return result;
};
